import { withInstall } from '@/utils'
import CosTable from './src/cosTable.vue'
import type { TableColumnType } from 'ant-design-vue'
export interface ColumnItem extends TableColumnType {
  dicData?: {
    label: string
    value: string | number
  }[]
  filterNoVal?: boolean
  dicUrl?: string
  langWidth: {
    zh: number | string
    en: number | string
  }
}
export default withInstall(CosTable)
